import { memo, forwardRef, SVGProps, Ref } from "react";

export const BoomIdLogo = memo(
  forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
      <div className={'svg-container'}>
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_22297_12875)">
            <path d="M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z" fill="url(#paint0_linear_22297_12875)"/>
            <path d="M42.5505 15.8448H24.8093V-2.43994H15.1973V-1.89642C15.1973 7.90466 7.25714 15.8448 -2.54395 15.8448V24.3698H15.1973V42.6545H24.8093V42.111C24.8093 32.3099 32.7494 24.3698 42.5505 24.3698V15.8448Z" fill="white"/>
          </g>
          <path d="M0.22428 8C0.22428 3.70559 3.70559 0.22428 8 0.22428H32C36.2944 0.22428 39.7757 3.70559 39.7757 8V32C39.7757 36.2944 36.2944 39.7757 32 39.7757H8C3.70559 39.7757 0.22428 36.2944 0.22428 32V8Z" stroke="#E5EBFC" stroke-width="0.448559"/>
          <defs>
            <linearGradient id="paint0_linear_22297_12875" x1="0.43797" y1="0.884907" x2="41.6371" y2="37.2084" gradientUnits="userSpaceOnUse">
              <stop stop-color="#00D4FF"/>
              <stop offset="0.6" stop-color="#AA00FF"/>
              <stop offset="0.95" stop-color="#F6077B"/>
            </linearGradient>
            <clipPath id="clip0_22297_12875">
              <path d="M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </div>
  ))
);
